import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import { reduxForm, getFormValues } from 'redux-form';
import { format, parse } from 'date-fns';
import { connect } from 'react-redux';

import { withNotifications } from '@components/hoc/withNotifications';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { InputField, Input, DateField, Date } from '@components/form';
import { getDelictByOffender } from '@modules/delicts/_delictsActions';
import { delictResolutionEnum } from '@modules/events/_eventsEnums';
import { required } from '@utils/validators';

const formName = 'delicts-by-offender';

const mapStateToProps = state => ({
  values: getFormValues(formName)(state)
});

const enhance = compose<any, any>(
  reduxForm({
    form: formName
  }),
  connect(mapStateToProps),
  withState('results', 'setResults', []),
  withState('showResults', 'setShowResults', false),
  withNotifications({ getDelictByOffender }),
  withHandlers({
    onSubmit: ({ setShowResults, handleLoader, getDelictByOffenderNotify, setResults }) => async formData => {
      handleLoader(true);
      const response = await getDelictByOffenderNotify(formData);
      if (response) {
        setResults(response);
      }
      setShowResults(true);
      handleLoader(false);
    }
  })
);

const DelictDetail = ({ delict }) => {
  return (
    <Row>
      {[
        {
          path: 'number',
          label: 'Číslo přestupku',
          default: 'neznámé'
        },
        {
          path: 'date',
          label: 'Datum přestupku',
          format: value => (value ? format(value, 'YYYY-MM-DD[T]HH:mm:ss') : 'neznámý'),
          width: 8
        },
        {
          path: 'type.fullName',
          label: 'Typ přestupku',
          default: 'neznámý'
        },
        {
          path: 'resolution',
          label: 'Způsob řešení',
          format: value => {
            const found = delictResolutionEnum.find(d => d.id === value);
            return found ? found.label : 'neznámé';
          }
        },
        {
          path: 'value',
          label: 'Výše pokuty',
          default: 'neznámá'
        },
        {
          path: 'clampPayed',
          label: 'Botička',
          format: value => {
            return value ? 'ano' : 'ne';
          }
        },
        {
          path: 'towPayed',
          label: 'Odtah',
          format: value => {
            return value ? 'ano' : 'ne';
          }
        },
        {
          path: 'towAmount',
          label: 'Vyrozumění',
          default: 'neznámé'
        }
      ].map(column => (
        <Col md={column.width ? column.width : 4} style={{ marginTop: '15px' }}>
          {column.label}:&nbsp;
          <span style={{ fontWeight: 500 }}>
            {column.format
              ? column.format(get(delict, column.path, undefined))
              : get(delict, column.path, column.default)}
          </span>
        </Col>
      ))}
    </Row>
  );
};

const View = ({ closeItem, handleSubmit, showResults, setShowResults, results, values, onSubmit }) => (
  <div style={{ margin: '15px' }}>
    {showResults ? (
      <>
        {showResults && results.length === 0 && <h4>Nic nenalezeno</h4>}
        <Grid fluid={true}>
          <Row>{results.map(r => <DelictDetail key={r.id} delict={r} />)}</Row>
        </Grid>
        <Button label={'Zpět'} onClick={() => setShowResults(false)} style={{ margin: '15px' }} />
        <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
      </>
    ) : (
      <form className="layout" onSubmit={handleSubmit(onSubmit)}>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <h4>Přehled přestupků</h4>
          </Row>
          <Row>
            {[{ label: 'Jméno *', name: 'firstName' }, { label: 'Příjmení *', name: 'lastName' }].map(
              ({ label, name }) => (
                <Col md={4} key={name}>
                  <InputField component={Input} name={name} label={label} validate={required} />
                </Col>
              )
            )}
            <Col md={4}>
              <DateField
                component={Date}
                name={'birthDate'}
                label={'Datum narození *'}
                validate={required}
                allowFuture={true}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <DateField
                component={Date}
                name={'from'}
                label={'Od'}
                maxDate={values.to ? parse(values.to) : undefined}
              />
            </Col>
            <Col md={6}>
              <DateField
                component={Date}
                name={'to'}
                label={'Do'}
                allowFuture={true}
                minDate={values.from ? parse(values.from) : undefined}
              />
            </Col>
          </Row>
        </Grid>
        <Button label={'Vyhledat'} type="submit" primary={true} style={{ margin: '15px' }} />
        <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
      </form>
    )}
  </div>
);

export const DelictsByOffenderForm = enhance(View);



// WEBPACK FOOTER //
// ./src/components/person/DelictsByOffenderForm.tsx